module.exports = {
	attachLabel: function(input, label, namespace = 'generic') {
		var forId = namespace + Math.floor(100 + Math.random() * 1000000);
		input.id = forId;
		label.htmlFor = forId;
	},
};